import React, { useState } from "react";
import PropTypes from "prop-types";
import { useConfig } from "@eis-poc/lib-discover-medical-mfes";
import {
  FooterLink,
  FooterSocialLink
} from "discover.medical.react-component-library";
import {
  StyledFooterContainer,
  StyledFooter,
  StyledFooterLogo
} from "./AppFooter.styled";
import { fetchTermsDlg } from "../../store/actions/termsDlg";
import { useDispatch } from "../../store";
import TermsOfUseDialog from "../TermsOfUseDialog";
import {
  AFFORDANCE,
  NAVIGATE_TO,
  logNavigationClicked
} from "../../utils/analytics";

const AppFooter = ({ onManageCookies }) => {
  const configContextData = useConfig();
  const dispatch = useDispatch();
  // :TODO: Handle failed config call
  const footerData = configContextData.footer || {};
  const { footerLinks, copyright, socialLinks, logo } = footerData;
  const [isTermsDlgOpen, setIsTermsDlgOpen] = useState(false);
  const closeTermsDialog = () => setIsTermsDlgOpen(false);

  const handleOnClick = (event) => {
    // If Terms & Condition link (which is at https://resources.ebsco.zone/ebsco-policies/terms-of-use.md) pop up dialog to display
    const target = event ? event?.target?.href : window.event?.srcElement?.href;
    if (target.indexOf("ebsco-policies") >= 0) {
      event.preventDefault();
      event.stopPropagation();
      fetchTermsDlg(dispatch, target);
      setIsTermsDlgOpen(true);
      return;
    }
    if (target.indexOf("mobile") >= 0) {
      logNavigationClicked({
        affordance: AFFORDANCE.footer,
        navigateTo: NAVIGATE_TO.mobile,
        navigateFrom: null
      });
    }
  };

  return (
    <StyledFooterContainer>
      <StyledFooter
        links={footerLinks?.map((link) =>
          !link.cookiesLink || onManageCookies ? (
            <FooterLink
              key={link.url}
              data-testid="footer-links"
              href={link.url}
              target={link.target}
              onClick={link.cookiesLink ? onManageCookies : handleOnClick}
            >
              {link.text}
            </FooterLink>
          ) : null
        )}
        socialLinks={socialLinks?.map((link) => (
          <FooterSocialLink
            key={link.url}
            data-testid="footer-social-links"
            glyph={link.name}
            href={link.url}
          />
        ))}
        logo={<StyledFooterLogo $logo={logo} src={logo?.src} alt={logo?.alt} />}
        copyright={copyright?.text}
      />
      <TermsOfUseDialog
        isTermsDlgOpen={isTermsDlgOpen}
        handleCloseDlg={closeTermsDialog}
      />
    </StyledFooterContainer>
  );
};

AppFooter.displayName = "AppFooter";
AppFooter.propTypes = {
  onManageCookies: PropTypes.func
};

export default AppFooter;
